<template>
  <div class="right_col phoneHail" role="main" ref="formContainer">
    <PassengerInfoTable
      ref="passengerInfoTable"
      :customerPhone="hailTaxiInfo.customer_phone"
      :serviceCommand="hailTaxiInfo.serviceCommand"
      :assignStrategy="assignStrategy"
      :distance="distance"
      :gender="gender"
      :isWarning="isWarning"
      :people="people"
      :vehicles="vehicles"
      :isSupport="isSupport"
      :isNearlyDriver="isNearlyDriver"
      :storeName="storeName"
      :isHailingClick="isHailingClick"
      @clearAllData="clearAllData"
      @updateHailTaxiInfo="updateHailTaxiInfo"
      @updateIsBlacklist="updateIsBlacklist"
      @searchCustomerInfo="searchCustomerInfo"
      @selectChangeHandler="selectChangeHandler"
      @hailingGeneralCar="hailingGeneralCar"
      @sameCustomerPhone="sameCustomerPhone"
      @updateSupportDriver="updateSupportDriver"
      @updateNearlyDriver="updateNearlyDriver"
      @updateContactPhone="updateContactPhone"
      @updateCustomerExist="updateCustomerExist"
    />
    <div
      class="row phoneHail__rowContainer"
      :class="{ yellow: picked === 1 }"
      @click="selectLocationMethod(1)"
    >
      <h4 class="col-md-2 phoneHail__title">
        <input
          class="phoneHail__radio"
          type="radio"
          name="address"
          value="1"
          v-model="picked"
        />
        地址輸入:
      </h4>
      <customer-search
        class="col-md-5"
        ref="customerSearch"
        :items="addresses"
        :gps="addressDetail"
        @changeAddressStatus="onAddressChange"
        @selected="customerSelected"
        @clearMainAddress="clearMainAddress"
        @setConfirmLocation="disconfirmLocation"
      />
      <div class="col-md-1">
        <i
          class="fa fa-check-circle fa-3x"
          style="color: #47d147"
          v-if="isConfirmLocation"
        ></i>
        <i class="fa fa-times-circle fa-3x" style="color: #f63e25" v-else></i>
      </div>
      <div class="col-md-2">
        <h4 v-if="shiftLoading" style="color: red">找尋排班區...</h4>
        <div v-else>
          <h4
            v-show="shiftName === '' && hailTaxiInfo.on.address !== null"
            style="color: red"
          >
            地點不屬於任何派遣服務區
          </h4>
          <h4 v-show="shiftName !== ''">{{ shiftName }}</h4>
        </div>
      </div>
      <div
        class="col-md-2"
        style="text-decoration: underline; color: blue"
        @click="openMap"
      >
        <h2>電子地圖</h2>
      </div>
    </div>
    <IntersectionLocation
      class="row phoneHail__rowContainer"
      ref="IntersectionLocation"
      :isPicked="picked === 2"
      @click="selectLocationMethod(2)"
      @update-location="updateLocationByIntersection"
    />
    <LandmarkLocation
      class="row phoneHail__rowContainer"
      ref="LandmarkLocation"
      :isPicked="picked === 3"
      @click="selectLocationMethod(3)"
      @update-location="updateLocationByLandmark"
    />
    <div class="row phoneHail__rowContainer">
      <div class="col-md-6">
        <HistoryLocation
          class="row"
          ref="HistoryLocation"
          :customerHistoryInfo="customerHistoryInfo"
          :isPicked="picked === 4"
          @click="selectLocationMethod(4)"
          @update-location="updateLocationByHistory"
        />
      </div>
      <div class="col-md-6">
        <div class="row phoneHail__subRow">
          <h4 class="col-md-2 phoneHail__title">上車備註:</h4>
          <input
            type="text"
            required="required"
            class="inputstyle col-md-4 fontSize16"
            placeholder=""
            v-model="hailTaxiInfo.command"
            data-command
          />
          <div class="col-md-2">
            <el-select
              v-model="note"
              placeholder="請選擇"
              @change="setNote(note)"
            >
              <el-option
                v-for="(item, index) in customerHistoryInfo.notes"
                :key="index"
                :label="item.command"
                :value="item.command"
              ></el-option>
            </el-select>
            <!-- <select class="phoneHail__select" v-model="note" @change="setNote(note)">
              <option disabled :value="-1">請選擇曾經服務</option>
              <option v-for ="(note, index) in customerHistoryInfo.notes" :key="index" :value="note.command">{{note.command}}</option>
            </select> -->
          </div>
          <div class="col-md-2">
            <note-select
              ref="noteSelect"
              @noteSelect="setNote"
              class="phoneHail__select"
            ></note-select>
          </div>
          <BaseButton
            class="phoneHail__button phoneHail__button--clear"
            :text="'清除'"
            :backgroundColor="'#394D5F'"
            :textColor="'#FFF'"
            :disabled="this.isHailingClick"
            @click="clearNoteAndRecord"
          />
        </div>
        <service-select
          class="row phoneHail__subRow"
          ref="serviceSelect"
          :serviceIdList="serviceIdList"
          :serviceNameList="serviceNameList"
          :customerPhone="hailTaxiInfo.customer_phone"
          @serviceListChange="serviceListChange"
          @service-chinese="setServiceSelected"
        />
      </div>
    </div>
    <div class="row phoneHail__rowContainer">
      <h4 class="col-md-2 phoneHail__title">排除呼號:</h4>
      <div class="col-md-4">
        <input
          type="text"
          class="phoneHail__inputField"
          v-model="blackList"
          placeholder="例如：123,321"
          data-blackList
        />
      </div>
    </div>
    <div class="row phoneHail__rowContainer">
      <h4 class="col-md-2 phoneHail__title">下車地點:</h4>
      <!-- <div class="col-md-4"> -->
      <off-customer-search
        class="phoneHail__offCustomerSearch col-md-4"
        ref="customerOffSearch"
        :items="offaddresses"
        :gps="offaddressDetail"
        @changeAddressStatus="onOffAddressChange"
        @selected="customerSelectedOffLcation"
        @clearMainAddress="clearMainAddress"
      />
      <!-- <AutoComplete ref="auto"
          :style="{ width: '100%' }"
          :area="inputArea"
          :id = "offAuto"
          @onLocationData="setOffLocation"/> -->
      <!-- </div> -->
      <BaseButton
        class="phoneHail__button phoneHail__button"
        :text="'不使用GPS，儲存下車地點'"
        :backgroundColor="'#337AB7'"
        :textColor="'#FFF'"
        @click="onClickSetNonGPSAddress"
      />
      <BaseButton
        class="phoneHail__button phoneHail__button--clear"
        :text="'清除'"
        :backgroundColor="'#d9534f'"
        :textColor="'#FFF'"
        @click="onClickOffLocationEmpty"
      />
      <div style="color: blue; margin-left: 10px">
        無需GPS也可以填寫下車地點，直接送出
      </div>
    </div>
    <div class="row phoneHail__rowContainer">
      <h4 class="col-md-2 phoneHail__title">指定叫車:</h4>
      <div class="col-md-2">
        <input
          type="text"
          class="phoneHail__inputField"
          v-model="designationList[0].callNumber"
          placeholder="隊編/呼號"
          data-designation1
        />
      </div>
      <div class="col-md-2">
        <input
          type="text"
          class="phoneHail__inputField"
          v-model="designationList[1].callNumber"
          placeholder="隊編/呼號"
          data-designation2
        />
      </div>
      <div class="col-md-2">
        <input
          type="text"
          class="phoneHail__inputField"
          v-model="designationList[2].callNumber"
          placeholder="隊編/呼號"
          data-designation3
        />
      </div>
    </div>
    <div class="row phoneHail__rowContainer">
      <h4 class="col-md-2 phoneHail__title">
        <input
          type="checkbox"
          class="phoneHail__checkbox"
          v-model="isSearchTakingPassengerCar"
        />
        預載詢(分)
      </h4>
      <div class="col-md-1">
        <input
          type="number"
          class="phoneHail__inputField"
          v-model="setTime"
          placeholder="分鐘數"
          @change="setSearchTakingPassengerCar"
        />
      </div>
    </div>
    <div class="row">
      <h4 class="col-md-8 color_red">
        {{ searchLocation.address }},{{ searchLocation.latitude }},{{
          searchLocation.longitude
        }}, 預估五公里內最近空車：{{ carNumber }}
      </h4>
    </div>
    <!-- <div class="row" v-show="!isWarning">
      <BaseButton
        class="phoneHail__button phoneHail__button--autoHailing"
        :text="'自動派遣'"
        :backgroundColor="'#26B99A'"
        :textColor="'#FFF'"
        :disabled="this.isHailingClick"
        @click="hailingGeneralCar"
      />
    </div> -->
    <!-- <div class="row phoneHail__rowContainer">
      <h4 class="col-md-2 phoneHail__title">臨時企業簽單:</h4>
      <div class="col-md-2">
        <input type="text" class="phoneHail__inputField" v-model="enterpriseOnLocation" placeholder="上車地點" data-designation1>
      </div>
      <div class="col-md-2">
        <input type="text" class="phoneHail__inputField" v-model="enterpriseOffLocation" placeholder="下車地點" data-designation2>
      </div>
      <div class="col-md-2">
        <input type="text" class="phoneHail__inputField" v-model="enterpriseNote" placeholder="簽單備註" data-designation3 >
      </div>
      <div class="col-md-2">
        <input type="text" class="phoneHail__inputField" v-model="enterpriseAmount" placeholder="簽單金額" data-designation3 >
      </div>
    </div> -->
    <div
      class="row phoneHail__rowContainer phoneHail__rowContainer--reservation"
    >
      <h4 class="col-md-2 phoneHail__title">後派預約時間：</h4>
      <div class="col-md-5">
        <date-select ref="reservationNonHail" class="row" />
      </div>
      <h4 class="col-md-1 phoneHail__title">提醒：</h4>
      <div class="col-md-1">
        <select
          class="phoneHail__select"
          v-model="remindTime"
          required=""
          @change="setRemindTime(remindTime)"
        >
          <option :value="5">5分</option>
          <option :value="10">10分</option>
          <option :value="15">15分</option>
          <option :value="20">20分</option>
          <option :value="25">25分</option>
          <option :value="30">30分</option>
        </select>
      </div>
      <BaseButton
        class="phoneHail__button phoneHail__button--saveReservation"
        :text="'後派單儲存'"
        :backgroundColor="'#337ab7'"
        :textColor="'#FFF'"
        :disabled="isSavingNonHailingBill"
        @click="saveNonHailingBill"
      />
      <BaseButton
        class="phoneHail__button phoneHail__button--ReservationPage"
        :text="'前往後派單頁面'"
        :backgroundColor="'#d9534f'"
        :textColor="'#FFF'"
        @click="changePage"
      />
    </div>
    <div
      class="row phoneHail__rowContainer phoneHail__rowContainer--previousReserve"
    >
      <PreviousReserveCar
        class="col-md-12"
        ref="previousReserveCar"
        :onLocation="hailTaxiInfo.on.address"
        :offLocation="hailTaxiInfo.off.address"
        :passengerNote="hailTaxiInfo.command"
        :contactPhone="hailTaxiInfo.contact_phone"
        :customerPhone="hailTaxiInfo.customer_phone"
        :name="gender === 0 ? '先生' : '小姐'"
        :onlng="hailTaxiInfo.on.longitude"
        :onlat="hailTaxiInfo.on.latitude"
        :offlng="hailTaxiInfo.off.longitude"
        :offlat="hailTaxiInfo.off.latitude"
        :userNumber="people === 10 ? 1 : people"
        :serviceList="hailTaxiInfo.customer_service"
        :selectedList="selectedList"
        :blackList="blackList"
        :cars="vehicles"
        :enterpriseOnLocation="enterpriseOnLocation"
        :enterpriseOffLocation="enterpriseOffLocation"
        :enterpriseAmount="enterpriseAmount"
        :enterpriseNote="enterpriseNote"
        @openReservationModal="openReservationModal"
      />
    </div>
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 1rem 0;
      "
    >
      <button @click="clearDispatch">更新排班站/派遣區圖資</button>
      <p
        v-if="$route.name === 'ServicePhoneHail'"
        class="footer__text"
        style="margin-bottom: 0"
      >
        資通行動科技{{ VERSION }}
      </p>
    </div>

    <HailResultModal
      ref="hailResultModal"
      :hailingBillData="hailingBillData"
      :customerPhone="this.hailTaxiInfo.customer_phone"
      :contactPhone="this.hailTaxiInfo.contact_phone"
      :orderIDArray="orderIDArray"
      :socket="socket"
      :customerId="customerId"
      :hasSendCar="hasSendCar"
      :isServerCheckReceiveOrder="isServerCheckReceiveOrder"
      :amountOfSendOrder="amountOfSendOrder"
      :deleteMark="deleteMark"
      @beforeCancel="beforeCancelAction"
      @sendSnsAction="sendSnsAction"
      @recallHailing="recallHailingCar"
      @releaseHaveSendedOrderCondition="releaseHaveSendedOrderCondition"
      @reqDeleteOrderMark="reqDeleteOrderMark"
    />

    <ReservationModal ref="reservationModal" @clearData="clearAllData()" />

    <MapDialog
      ref="mapDialogReference"
      :latitude="mapLatitude"
      :longitude="mapLongitude"
      @mapGps="setMapGps"
    />
  </div>
</template>

<script>
import API from '@/assets/js/libs/API'
import { mapState, mapMutations } from 'vuex'
import { reqServiceList } from '@/api/hail'
import AutoComplete from '../mapComponent/AutoComplete.vue'
import BehaviorRecorder from '../../assets/js/libs/BehaviorRecorder'
import { cookies } from '@/utils/cookies'
import CustomerSearch from '@/components/tool/CustomerAutoComplete'
import OffCustomerSearch from '@/components/tool/CustomerAutoComplete'

import DateSelect from '../../components/tool/DateSelectNonLimit'
import HailResultModal from '../../components/hailing/HailResultModal'
import kmlTool from '@/assets/js/tool/kmlTool.js'
import MinorNote from '@/pages/forms/MinorNote'
import NoteSelect from '@/components/tool/customerNoteSelect'
import PassengerInfoTable from '@/pages/hailTaxi/PassengerInfoTable'
import PreviousReserveCar from '@/components/PreviousReserveCar'
import RefactorSection from '@/pages/forms/RefactorSection'
import ReservationModal from '@/components/PreviousReserveModal'
import ServiceSelect from '../../components/hailing/ServiceSelect'
import IntersectionLocation from '@/mixins/PhoneHail/IntersectionLocation'
import LandmarkLocation from '@/mixins/PhoneHail/LandmarkLocation'
import HistoryLocation from '@/mixins/PhoneHail/HistoryLocation'
import BaseButton from '@/components/common/button/BaseButton'
import { isCoordinateMatched } from '@/assets/js/tool/coordinateUtils'
import { isTimeInvalid } from '@/assets/js/tool/timeUtils'
import { generateString } from '@/utils/generateString'
import { behaviorStr, getLineUrl, orderRemind } from '@/utils/helper'
import socketMixin from '@/mixins/socket'
import coordinatePositioning from '@/mixins/PhoneHail/coordinatePositioning'
import MapDialog from '../../components/element_ui/MapDialog'
import localStorageUtils from '../../assets/js/tool/localStorageUtils'
import { Url } from '../../assets/js/libs/LineUrl'
import Record_behavir from '../../assets/js/libs/FirebaseAPI/RecordBill'
import Customer from '../../assets/js/libs/Customer'
import { appVersion } from '@/constants/general'

// 送出後多久仍未出現結果視窗，就視為派車流程中斷並釋放鎖定（毫秒）
const HAILING_LOCK_TIMEOUT = 30 * 1000

let customer = new Customer()
let record = new Record_behavir()
export default {
  name: 'PhoneHail',
  mixins: [coordinatePositioning, socketMixin],
  data() {
    return {
      VERSION: appVersion,
      mapLatitude: 23.040909,
      mapLongitude: 120.297996,
      shiftLoading: false,
      carNumber: '',
      onAuto: 'onAuto',
      offAuto: 'offAuto',
      hailingBillData: '',
      inputArea: '', // 預設地區
      vehicles: 1, // TODO: 評估跟 cars 合併
      saveNote: [],
      service: [],
      list: [],
      selectedList: '',
      gender: 0,
      hailTaxiInfo: {
        customer_phone: null,
        on: {
          latitude: null,
          longitude: null,
          address: null,
        },
        off: {
          latitude: null,
          longitude: null,
          address: null,
        },
        customer_service: null,
        serviceCommand: null,
        command: null,
        contact_phone: null,
        cars: 1,
      },
      customerHistoryInfo: {
        notes: [],
        serviceNotes: [],
        getInInfors: [],
        gps: [],
        customerNote: [],
        classStyle: [],
        notFinishOnlocationDatas: [],
        name: '',
      },
      designationList: [
        { callNumber: null },
        { callNumber: null },
        { callNumber: null },
      ],
      customerId: null,
      note: '',
      blackList: null,
      hailingMethod: 0, // 0: 一般叫車、1: 指定轎車
      addresses: [], // pick:1
      addressDetail: [], // pick:1
      offaddresses: [], // pick:1
      offaddressDetail: [], // pick:1
      people: 10,
      isHailingClick: false,
      isSavingNonHailingBill: false,
      orderIDArray: [],
      distance: 10000,
      shiftName: '',
      dispatchAreaName: '',
      reservation: {
        on_address: null,
      },
      assignStrategy: 1,
      // 乘客是否是黑名單的值，如果是true的話電話派車會不給直接派
      isWarning: false,
      isSupport: false,
      remindTime: 20,
      isSearchTakingPassengerCar: false,
      setTime: 0,
      hasSendCar: false,
      isServerCheckReceiveOrder: false,
      amountOfSendOrder: 0,
      isNearlyDriver: true,
      amountOfCounter: 0,
      loader: null,
      tmpPeople: 1,
      enterpriseOnLocation: null,
      enterpriseOffLocation: null,
      enterpriseAmount: null,
      enterpriseNote: null,
      serviceIdList: [],
      serviceNameList: [],
      storeName: '',
      ajaxRequest: null,
      deleteMark: '',
      orderRemindIntervalId: '',
      isCustomerExist: false, // 用於判斷是要新增還是更新使用者資料
    }
  },
  methods: {
    ...mapMutations('hail', {
      vx_setServiceList: 'setServiceList',
      vx_setPhoneList: 'setPhoneList',
    }),
    getCommands() {
      var notesArr = Array.isArray(this.customerHistoryInfo.notes)
        ? this.customerHistoryInfo.notes.map(function (item) {
            return item.command || ''
          })
        : []
      if (this.hailTaxiInfo.command && this.hailTaxiInfo.command !== '') {
        notesArr.push(this.hailTaxiInfo.command)
      }
      return notesArr
        .filter(function (item) {
          return item !== ''
        })
        .join(',')
    },
    sendSnsAction(item) {
      if (
        this.hailTaxiInfo.contact_phone.length === 10 &&
        this.hailTaxiInfo.contact_phone[0] === '0' &&
        this.hailTaxiInfo.contact_phone[1] === '9'
      ) {
        let payload = {
          phone: this.hailTaxiInfo.contact_phone,
          callNumber: item.driverCallNumber,
          orderId: item.orderId,
          messageType: item.messageType || '加入Line好友',
          url: getLineUrl(),
        }
        API.post(`sns/web`, payload)
          .then((data) => {
            if (data.success) {
              return this.$msg('傳送成功')
            }
            return this.$msg('傳送失敗')
          })
          .catch((e) => {
            console.error(e)
          })
      } else {
        this.$msg('此號碼不是手機號碼')
      }
    },
    clearDispatch() {
      localStorageUtils.localStorageClear()
    },
    onClickSetNonGPSAddress() {
      if (this.hailTaxiInfo.off.address === null) {
        this.hailTaxiInfo.off.address =
          this.$refs.customerOffSearch.getAddress()
      } else {
        this.$msg('下車地點已儲存')
      }
    },
    setMapGps(val) {
      const { latitude, longitude, address } = val
      this.listenAddressFromMap({
        latitude,
        longitude,
        address,
      })
      this.picked = 1
    },
    setSearchTakingPassengerCar() {
      this.isSearchTakingPassengerCar = parseInt(this.setTime) !== 0
    },
    releaseHaveSendedOrderCondition() {
      this.hasSendCar = false
      this.isHailingClick = false
    },
    // 重複派遣提醒：僅針對本頁送出鎖定（防連點重複發單）
    showDuplicateHailAlert(orderIds) {
      const lines = ['偵測到重複派遣']
      if (orderIds && orderIds.length > 0) {
        lines.push(`單號：${orderIds.join('、')}`)
      }
      lines.push('原因：偵測到連續點擊自動派遣')
      lines.push('請至叫車紀錄查看!')
      return this.$alert(lines.join('<br/>'), '重複單號提醒', {
        dangerouslyUseHTMLString: true,
      })
    },
    openReservationModal(val) {
      this.saveCustomerAPI('reservation')
      this.$refs.reservationModal.openModal(val)
    },
    _isEmpty(val) {
      if (Array.isArray(val)) {
        return val.length === 0
      }
      return (
        !val ||
        val === null ||
        val.replace(/^\s+|\s+$/g, '') === '' ||
        val.trim() === ''
      )
      // 其實可以砍剩 !val || val.trim() === ""
    },
    _isNotEmpty(val) {
      return !this._isEmpty(val)
    },
    changePage() {
      this.$router.push({ name: 'RecordHailBill' })
    },
    showReservation() {
      return cookies.get('GladTeamCode') !== '888'
    },
    openMap() {
      this.$refs.mapDialogReference.openDialog(this.searchLocation)
    },
    async hailingGeneralCar() {
      // 先檢查鎖定，避免清資料時解除 hasSendCar 導致重複送出
      if (this.hasSendCar || this.isHailingClick) {
        BehaviorRecorder.record('顯示提醒', '派車頁面', '重複單號提醒')
        return this.showDuplicateHailAlert(this.orderIDArray)
      }

      // 立刻鎖按鈕；驗證失敗要釋放，成功則維持到關結果視窗／清除
      this.isHailingClick = true
      this.startHailingLockWatchdog()

      try {
        if (this.isUserValidToCallCar()) {
          this.releaseHaveSendedOrderCondition()
          return alert('目前此帳號無法用立即派車功能')
        }

        if (!this.phoneCheck(this.hailTaxiInfo.contact_phone)) {
          this.releaseHaveSendedOrderCondition()
          return
        }

        if (this.picked === 0) {
          this.releaseHaveSendedOrderCondition()
          return alert('請選擇地址')
        }

        this.hasSendCar = true
        // 清空hailResultModal的資料（不再解除鎖定）
        this.$refs.hailResultModal.initialDataWithoutHideModal()

        BehaviorRecorder.record('點擊', '派車頁面', '自動派遣:')
        const isDesignatedNotEmpty = this.designationList.find((designated) =>
          this._isNotEmpty(designated.callNumber),
        )
        this.hailingMethod = isDesignatedNotEmpty ? 1 : 0
        this.updateHailTaxiOnInfo()
        this.SendHailingGeneralCarData()
        // 成功路徑維持鎖定，直到關結果視窗／清除／明確失敗再解鎖
      } catch (e) {
        this.onHailingError(e)
      }
    },
    // 派車流程任何未預期的錯誤都要釋放鎖定，避免按鈕永久停用
    onHailingError(e) {
      console.error('自動派遣發生錯誤', e)
      if (!this.isHailingModalVisible()) {
        this.releaseHaveSendedOrderCondition()
      }
      alert('自動派遣發生錯誤，請再試一次')
    },
    // 鎖定看門狗：結果視窗未出現超時，或出現後被關閉但未經正常解鎖，就自動釋放
    startHailingLockWatchdog() {
      this.stopHailingLockWatchdog()
      this.hailingLockedAt = Date.now()
      this.hailingModalShown = false
      this.hailingLockWatchdog = setInterval(this.checkHailingLock, 1000)
    },
    stopHailingLockWatchdog() {
      if (this.hailingLockWatchdog) {
        clearInterval(this.hailingLockWatchdog)
        this.hailingLockWatchdog = null
      }
    },
    checkHailingLock() {
      if (!this.isHailingClick) {
        this.stopHailingLockWatchdog()
        return
      }
      if (this.isHailingModalVisible()) {
        this.hailingModalShown = true
        return
      }
      const timedOut = Date.now() - this.hailingLockedAt > HAILING_LOCK_TIMEOUT
      if (this.hailingModalShown || timedOut) {
        this.stopHailingLockWatchdog()
        this.releaseHaveSendedOrderCondition()
      }
    },
    isHailingModalVisible() {
      return typeof $ === 'function' && $('#hailingModal').is(':visible')
    },
    updateHailTaxiOnInfo() {
      this.picked === 1
        ? this.updateHailTaxiOnByFillLocation()
        : this.updateHailTaxiOnBySelectLocation()

      if (
        this.hailTaxiInfo.on.address === null &&
        this.searchLocation.address !== null
      ) {
        this.setOnLocation(this.searchLocation)
      }
    },
    updateHailTaxiOnByFillLocation() {
      if (this.fillLocationMethod === 0) {
        const { latitude, longitude } = this.mainSelectLocaiton
        this.hailTaxiInfo.on = {
          latitude,
          longitude,
          address: this.$refs.customerSearch.getAddress(),
        }
      }
      if (this.fillLocationMethod === 1 || this.fillLocationMethod === 2) {
        this.hailTaxiInfo.on.address = this.$refs.customerSearch.getAddress()
      }
    },
    updateHailTaxiOnBySelectLocation() {
      const selectLcationStrategy = {
        2: this.intersectionLocation,
        3: this.landmarkLocation,
        4: this.historyLocation,
      }
      const { latitude, longitude, address } =
        selectLcationStrategy[this.picked]
      this.hailTaxiInfo.on = { latitude, longitude, address }
      if (this.picked === 4) this.fillLocationMethod = 1
    },
    SendHailingGeneralCarData() {
      if (this.searchLocation.address === null) {
        alert('請輸入上車地點')
        this.releaseHaveSendedOrderCondition()
        return
      }
      if (
        this.hailTaxiInfo.customer_phone === null ||
        this.hailTaxiInfo.customer_phone === undefined
      ) {
        alert('請輸入乘客電話')
        this.releaseHaveSendedOrderCondition()
        return
      }
      this.saveCustomerAPI('immediatelyHailing').catch((e) =>
        this.onHailingError(e),
      )
    },
    getCustomerInfo(task) {
      const customerInfo = {
        phone: this.hailTaxiInfo.customer_phone,
        gender: this.gender === 0,
        contactPhone:
          this.hailTaxiInfo.contact_phone === null ||
          this.hailTaxiInfo.contact_phone === ''
            ? this.hailTaxiInfo.customer_phone
            : this.hailTaxiInfo.contact_phone,
        onLocationLng1: `${this.hailTaxiInfo.on.longitude}`,
        onLocationLat1: `${this.hailTaxiInfo.on.latitude}`,
        name: this.customerHistoryInfo.name,
        token: cookies.get('user'),
        commands: this.getCommands(),
        serviceCommand: this.hailTaxiInfo.serviceCommand || '',
        // 服務 ID 排序與格式化，確保送出格式正確
        serviceList: this.formatAndSortServiceList(
          this.hailTaxiInfo.customer_service,
        ),
        event: 'phone',
      }

      customerInfo.onLocation1 =
        task === 'reservation'
          ? this.reservation.on_address
          : this.hailTaxiInfo.on.address

      if (this._isNotEmpty(this.hailTaxiInfo.serviceCommand)) {
        // 需要儲存客服資料，新資料直接覆蓋舊資料
        customerInfo.serviceCommand = this.hailTaxiInfo.serviceCommand
      }

      if (this._isNotEmpty(this.hailTaxiInfo.command)) {
        customerInfo.command = this.hailTaxiInfo.command
      }
      return customerInfo
    },
    //  將服務 ID 做型別判斷、排序並轉為字串
    formatAndSortServiceList: function (rawServiceList) {
      if (
        !rawServiceList ||
        (Array.isArray(rawServiceList) && rawServiceList.length === 0)
      )
        return ''
      var serviceIdArray = Array.isArray(rawServiceList)
        ? rawServiceList
        : typeof rawServiceList === 'string'
          ? rawServiceList.split(',')
          : []
      return serviceIdArray
        .map(function (id) {
          return parseInt(id, 10)
        })
        .filter(function (id) {
          return !isNaN(id)
        })
        .sort(function (a, b) {
          return a - b
        })
        .join(',')
    },
    getHailingBillComment() {
      const passengerComment = []

      const phone = this._isNotEmpty(this.hailTaxiInfo.contact_phone)
        ? `聯絡電話:${this.hailTaxiInfo.contact_phone}`
        : `聯絡電話:${this.hailTaxiInfo.customer_phone}`

      const serviceCommand =
        this.hailTaxiInfo.customer_service !== null ? this.selectedList : null

      this._isNotEmpty(this.hailTaxiInfo.command) &&
        passengerComment.push(this.hailTaxiInfo.command)
      this._isNotEmpty(phone) && passengerComment.push(phone)
      this._isNotEmpty(serviceCommand) && passengerComment.push(serviceCommand)

      const comment = this._isNotEmpty(passengerComment)
        ? passengerComment.join(',')
        : ''
      return comment
    },
    getHailingBillInfo() {
      let info = {
        onLocation: this.hailTaxiInfo.on.address,
        offLocation: this.hailTaxiInfo.off.address,
        serviceList:
          this.hailTaxiInfo.customer_service === ''
            ? null
            : this.hailTaxiInfo.customer_service,
        passenComment:
          this.getAmountOfPassenger() + this.getHailingBillComment(),
        onLocationLat: this.hailTaxiInfo.on.latitude,
        onLocationLng: this.hailTaxiInfo.on.longitude,
        passengerPhone: this.hailTaxiInfo.customer_phone,
        offLocationLng: this.hailTaxiInfo.off.longitude,
        offLocationLat: this.hailTaxiInfo.off.latitude,
        cars: this.vehicles,
        account: cookies.get('GladServiceNumber'),
        passenNum: this.tmpPeople,
        seatNumber: this.tmpPeople,
        callCarType: 0,
        payType: 0,
        taxiSort: 2,
        register: 4, //TODO: 之後去除
        platform: 4,
        callMethod: 1,
        distance: this.distance,
        enterpriseOnLocation: this.enterpriseOnLocation,
        enterpriseOffLocation: this.enterpriseOffLocation,
        enterpriseAmount: this.enterpriseAmount,
        enterpriseNote: this.enterpriseNote,
      }
      info = this._checkAssignStrategy(info)
      if (this.isSupport) info.anotherTeamCode = '001'
      /* 黑名單 */
      if (this._isNotEmpty(this.blackList)) {
        let list = this.blackList.trim().split(',')
        info.blackList = list
          .filter((item) => item !== '')
          .map((item) => ({
            teamCode: cookies.get('GladTeamCode'),
            callNumber: item.trim(),
          }))
      }
      /* 預載詢 */
      if (this.isSearchTakingPassengerCar) {
        info.method = 'priorSearch'
        info.priorSearcharrivalTime = parseInt(this.setTime)
      }
      /* 搶單- 最近一個司機搶中 */
      info.recentDriverFirst = this.isNearlyDriver
      return info
    },
    _checkAssignStrategy(info) {
      /* 保留已選派遣區；shiftProgram 一律帶出（與後派單一致）
       * assignStrategy=3 最近空車 → shiftProgram=3
       * assignStrategy=4 直派(尾班) → shiftProgram=1 + shiftSort=-1 */
      if (this.dispatchAreaName !== '') {
        info.dispatchAreaName = this.dispatchAreaName
      }
      info.shiftProgram = this.assignStrategy === 4 ? 1 : this.assignStrategy
      if (this.assignStrategy === 4) {
        info.shiftSort = -1
      }
      return info
    },
    getDesignationDriver() {
      return this.designationList
        .filter((listItem) => this._isNotEmpty(listItem.callNumber))
        .map((item) => ({
          teamCode: cookies.get('GladTeamCode'),
          callNumber: item.callNumber,
        }))
    },
    async reqSubmitOrder(info) {
      return API.post('staff_hail_a_taxi', info).catch((e) => {
        console.error(e)
        // 如果是 axios error，回傳 response.data，否則回傳錯誤物件
        if (e.response && e.response.data) {
          return e.response.data
        }
        return e
      })
    },
    // 若是超過65秒還未從後端得到訂單資料，改用此api取得訂單資料
    async reqOrderTimeout(mark) {
      return API.get(
        `staff_hail_a_taxi/order?staff_hail_a_taxi_mark=${mark}`,
      ).catch((e) => console.error(e))
    },
    // 若是已經取得訂單資料，多回傳此req取消訂單註記
    async reqDeleteOrderMark(mark) {
      // console.log("delete order mark", mark);
      try {
        await API.delete(
          `staff_hail_a_taxi/order_mark?staff_hail_a_taxi_mark=${mark}`,
        )
      } catch (e) {
        console.error(e)
      }
    },
    reqGetOrderId(staffHailATaxiMark, orderIdx = null) {
      let attempt = 0
      const intervalId = setInterval(async () => {
        try {
          // send the request
          const { result: orderId } = await API.get(
            `staff_hail_a_taxi/order_id?staff_hail_a_taxi_mark=${staffHailATaxiMark}`,
          )
          attempt += 1
          if (orderId) {
            this.orderIDArray.push(orderId)
            clearInterval(intervalId)
          } else if (attempt >= 4 && !orderId) {
            this.$refs.hailResultModal.stopCountTime()
            clearInterval(intervalId)
            if (orderIdx) {
              this.$alert(
                '目前系統忙碌中，請關閉視窗，重新派車',
                `無法取得第${orderIdx}張訂單的訂單編號`,
              )
            } else {
              this.$alert(
                '目前系統忙碌中，請關閉視窗，重新派車',
                '無法取得訂單編號',
              )
            }
          }
        } catch (e) {
          console.error(e)
        }
      }, 1500)
    },
    async nonAssginGeneralhailingTaxi(info) {
      this.amountOfCounter = 0
      try {
        await this._socketConnection('叫車頁面叫車時觸發的socket連線')
      } catch (e) {
        // 連線失敗時結果視窗不會開啟，需釋放鎖定讓使用者可以再派
        console.error('socket 連線失敗', e)
        this.releaseHaveSendedOrderCondition()
        alert('無法連線派車服務，請稍後再試')
        return
      }
      this.orderIDArray = []
      this.socket.sendBuffer = []
      // 紀錄訂單亂數用,需要8字元
      this.deleteMark = generateString(8)
      info.staffHailATaxiMark = this.deleteMark
      this.hailingBillData = info
      this.hailingOpenModal()
      this.isServerCheckReceiveOrder = true
      if (this.amountOfCounter === 0) {
        this.$refs.hailResultModal.startCountTime(true)
        this.amountOfCounter = 1
      }
      // multiple cars
      this.$refs.hailResultModal.setManyCarsState(this.vehicles)
      if (this.vehicles > 1) {
        BehaviorRecorder.record(
          '顯示提醒',
          '派車頁面',
          // "多輛車派遣，需要先取得groupId," + JSON.stringify(info)
          behaviorStr(
            info,
            this.getHailingBillComment(),
            this.hailTaxiInfo.contact_phone,
            this.vx_serviceList,
            this.assignStrategy,
            this.isNearlyDriver,
          ),
        )
        await API.post('service/callcar/group', { cars: this.vehicles })
          .then((res) => {
            if (res.result === null) return
            info.groupId = res.result
          })
          .catch((e) => {
            console.error('group', e)
          })
        // 若是多台車，則須發送多次request
        const markArr = []
        for (let idx = 0; idx < this.vehicles; idx++) {
          if (idx == 0) {
            markArr.push(info.staffHailATaxiMark)
          } else {
            markArr.push(generateString(8))
          }
        }
        this.deleteMark = markArr
        for (let idx = 0; idx < this.vehicles; idx++) {
          setTimeout(async () => {
            info.staffHailATaxiMark = markArr[idx]
            this.reqGetOrderId(markArr[idx], idx + 1)
            let result
            let res = await this.reqSubmitOrder(info)
            if (res.message.includes('timeout')) {
              const response = await this.reqOrderTimeout(markArr[idx])
              // TODO: electron 若更新須改回hasOwn
              result = response.hasOwnProperty('result')
                ? response.result
                : null
            } else {
              result = res.result
            }

            /* if (res) {
              result = await res.result;
            } else {
              const response = await this.reqOrderTimeout(markArr[idx]);
              // TODO: electron 若更新須改回hasOwn
              result = response.hasOwnProperty("result") ? response.result : null;
            } */

            if (result) {
              this.orderIDArray.push(result.orderId)
              // console.log("orderIDArray", this.orderIDArray);
              // NOTE: 發送此request才能觸發訂單異常
              this.createRecordDriverAbnormalList(result.orderId)
              this.setHailResultModal(result)
            } else {
              this.$alert(
                '目前無法取得派車結果，請先到叫車紀錄查看',
                `無法取得第${idx + 1}張派車單的結果`,
              )
            }
          }, 3000 * idx)
        }
      } else {
        BehaviorRecorder.record(
          '顯示提醒',
          '派車頁面',
          behaviorStr(
            info,
            this.hailTaxiInfo.command,
            this.hailTaxiInfo.contact_phone,
            this.vx_serviceList,
            this.assignStrategy,
            this.isNearlyDriver,
          ),
        )
        this.reqGetOrderId(this.deleteMark)
        let result
        let res = await this.reqSubmitOrder(info)

        // 檢查是否為錯誤回應
        if (res && res.error) {
          // API 回傳錯誤，直接顯示錯誤訊息
          let errorMessage = ''
          if (res.error.message && res.error.message.trim() !== '') {
            errorMessage = res.error.message
          }

          // 組合訊息內容
          let messageContent = '目前無法取得派車結果，請先到叫車紀錄查看'
          if (errorMessage) {
            messageContent += `<br/><span style="color: red;">${errorMessage}</span>`
          }

          this.$alert(messageContent, '無法取得派車結果', {
            dangerouslyUseHTMLString: true,
          })
          this.releaseHaveSendedOrderCondition()
          return
        }

        // 正常回應處理
        if (res && res.message && res.message.includes('timeout')) {
          const response = await this.reqOrderTimeout(this.deleteMark)
          // TODO: electron 若更新須改回hasOwn
          result = response.hasOwnProperty('result') ? response.result : null
        } else {
          result = res.result
        }
        /* if (res) {
          result = res.result;
        } else {
          const response = await this.reqOrderTimeout(this.deleteMark);
          // TODO: electron 若更新須改回hasOwn
          result = response.hasOwnProperty("result") ? response.result : null;
        } */
        if (result) {
          this.createRecordDriverAbnormalList(result.orderId)
          this.orderIDArray.push(result.orderId)
          this.setHailResultModal(result)
          this.amountOfSendOrder++
          this.hasSendCar = true //派出時維持鎖定，直到關窗／清除
          this.isHailingClick = true
        } else {
          // 取得 API 錯誤訊息
          let errorMessage = ''
          if (res && res.message && !res.message.includes('timeout')) {
            errorMessage = res.message
          } else if (res && typeof res === 'string') {
            errorMessage = res
          }

          // 組合訊息內容
          let messageContent = '目前無法取得派車結果，請先到叫車紀錄查看'
          if (errorMessage) {
            messageContent += `<br/><span style="color: red;">${errorMessage}</span>`
          }

          this.$alert(messageContent, '無法取得派車結果', {
            dangerouslyUseHTMLString: true,
          })
          this.releaseHaveSendedOrderCondition()
        }
      }
    },
    setHailResultModal(result) {
      /* console.log(result) */
      // 結果回來不解除鎖定，避免客服再點自動派遣產生重複單
      if (this.vehicles !== 1) {
        if (
          result.orderStatus !== '無車輛可派。' &&
          this.orderIDArray.indexOf(result.orderId) !== -1
        ) {
          let recordInfo = {}
          recordInfo.type = '立即單'
          recordInfo.event = '回傳立即單'
          recordInfo.code = cookies.get('GladTeamCode')
          recordInfo.id = result.orderId
          recordInfo.note = '多輛車'
          recordInfo.user_name = cookies.get('GladName')
          recordInfo.user_id = ''
          record.postRecord(recordInfo)
          this.$refs.hailResultModal.hailingTaxiResult(result)
          return
        }
        if (this.orderIDArray.indexOf(orderId) !== -1) {
          this.$refs.hailResultModal.hailingTaxiResult(result)
          return
        }
      }
      if (
        result.orderStatus !== '無車輛可派。' &&
        result.orderId === this.orderIDArray[0]
      ) {
        let recordInfo = {}
        recordInfo.type = '立即單'
        recordInfo.event = '回傳立即單'
        recordInfo.code = cookies.get('GladTeamCode')
        recordInfo.id = result.orderId
        recordInfo.note = '單一'
        recordInfo.user_name = cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        this.$refs.hailResultModal.hailingTaxiResult(result)
        return
      }
      if (result.orderId === this.orderIDArray[0]) {
        let recordInfo = {}
        recordInfo.type = '立即單'
        recordInfo.event = '回傳立即單'
        recordInfo.code = cookies.get('GladTeamCode')
        recordInfo.id = result.orderId
        recordInfo.note = '單一，無車輛可派'
        recordInfo.user_name = cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        this.$refs.hailResultModal.hailingTaxiResult(result)
      }
    },
    async hailingTaxi() {
      try {
        let info = this.getHailingBillInfo()
        /* 不指定叫車 */
        if (this.hailingMethod === 0) {
          this.nonAssginGeneralhailingTaxi(info).catch((e) =>
            this.onHailingError(e),
          )
          return
        }
        /* 指定叫車 */
        if (this.vehicles > 1) {
          // 結果視窗不會開啟，必須在這裡釋放鎖定，否則按鈕永久停用
          this.releaseHaveSendedOrderCondition()
          alert('目前指定叫車，不支援多台')
          return
        }
        info.designationDriver = this.getDesignationDriver()
        this.nonAssginGeneralhailingTaxi(info).catch((e) =>
          this.onHailingError(e),
        )
      } catch (e) {
        this.onHailingError(e)
      }
    },
    hailingOpenModal() {
      BehaviorRecorder.record('顯示提醒', '派車頁面', '打開派車視窗')
      this.$refs.hailResultModal.openModal()
      this.$refs.hailResultModal.clearHailingResultArray()
    },
    beforeCancelAction(val) {
      BehaviorRecorder.record('點擊', '派車頁面', '在未叫到車時，取消')
      this.orderIDArray = []
      this.$refs.hailResultModal.hailingTaxiResult(val)
    },
    updateCustomerHistoryBySearchResult(result) {
      const {
        commands,
        serviceCommands,
        getinInformations,
        notFinishOnlocationDatas,
        name,
        phone,
      } = result
      this.hailTaxiInfo.contact_phone = phone /* 聯絡電話預設與進線電話相同 */
      this.customerHistoryInfo.notes = JSON.parse(commands)
      this.customerHistoryInfo.serviceNotes = JSON.parse(serviceCommands)
      this.customerHistoryInfo.getInInfors = JSON.parse(getinInformations)
      this.customerHistoryInfo.notFinishOnlocationDatas =
        notFinishOnlocationDatas
      this.customerHistoryInfo.name = name
      this.customerHistoryInfo.classStyle = JSON.parse(getinInformations).map(
        (elem) => {
          const { coordinates } = elem.getinInformation.passenger_getin_gps
          return notFinishOnlocationDatas.find((nf) =>
            isCoordinateMatched(coordinates, nf.unFinishOnGps.coordinates),
          )
            ? 'hailing_address_red'
            : 'color_gray'
        },
      )
    },
    async searchCustomerInfo() {
      // 找尋是否有此乘客舊資料
      this.clearNote()
      this.note = ''
      this.$refs.previousReserveCar.resetting()
      if (this._isEmpty(this.hailTaxiInfo.customer_phone))
        return this.$msg('請輸入電話號碼')
      this._clearData()
      try {
        const res = await API.get(
          `customer/v2/?phone=${this.hailTaxiInfo.customer_phone}`,
        )
        // 有找到資料
        this.isCustomerExist = true
        const {
          gender,
          isWarning,
          blacklist,
          serviceCommands,
          serviceList,
          serviceNameList,
          storeName,
          phoneList,
        } = res.result
        this.gender = gender === 'female' ? 1 : 0
        this.isWarning = isWarning
        this.blackList = blacklist
          ? blacklist.map((item) => item.callNumber).join(',')
          : null
        this.storeName = storeName
        this.vx_setPhoneList(phoneList)
        if (serviceList !== undefined) {
          let array = serviceList.split(',')
          for (let i = 0; i < array.length; i++) {
            this.serviceIdList.push(parseInt(array[i]))
          }
        } else {
          this.serviceIdList = []
        }
        this.serviceNameList = serviceNameList
        this.hailTaxiInfo.serviceCommand = this.sortOutServiceCommand(
          JSON.parse(serviceCommands),
        )
        this.updateCustomerHistoryBySearchResult(res.result)
      } catch (e) {
        // 沒有找到資料
        this.isCustomerExist = false
        this.sameCustomerPhone()
        this.$msg(
          e.data && e.data.error && e.data.error.message
            ? e.data.error.message.replace('商家', '顧客')
            : '查無資料',
        )
      }
    },
    sortOutServiceCommand(note) {
      return note
        .filter(
          (item) =>
            item.serviceCommand !== undefined && item.serviceCommand !== '',
        )
        .map((item) => item.serviceCommand)
        .join(',')
    },
    selectChangeHandler({ item, value }) {
      this[item] = parseInt(value)
    },
    updateHailTaxiInfo({ item, value }) {
      this.hailTaxiInfo[item] = value
    },
    updateIsBlacklist(value) {
      this.isWarning = value
    },
    updateSupportDriver(value) {
      this.isSupport = value
    },
    updateNearlyDriver(value) {
      this.isNearlyDriver = value
    },
    clearAllData() {
      BehaviorRecorder.record('點擊', '派車頁面', '清除所有資料')
      this.hailTaxiInfo.customer_phone = null
      this._clearData()
      this.clearNote()
    },
    getAmountOfPassenger() {
      if (parseInt(this.people) === 10) {
        this.tmpPeople = 1
        // this.people = 1
        return ''
      }
      this.tmpPeople = this.people
      return `${this.people}人,`
    },
    initData() {
      this.amountOfCounter = 0
      this.assignStrategy = 1
      this.distance = 10000
      this.fillLocationMethod = -1
      this.amountOfSendOrder = 0
      this.isServerCheckReceiveOrder = false
      this.releaseHaveSendedOrderCondition()
      this.hailTaxiInfo.contact_phone = null
      this.hailTaxiInfo.on = { latitude: null, longitude: null, address: null }
      this.hailTaxiInfo.off = {
        latitude: null,
        longitude: null,
        address: null,
      }
      this.hailTaxiInfo.customer_service = null
      this.hailTaxiInfo.serviceCommand = null
      this.hailTaxiInfo.command = null
      this.isConfirmLocation = false
      this.isSearchTakingPassengerCar = false
      this.isSupport = false
      this.people = 10
      this.tmpPeople = 1
      this.reservation.on_address = null
      this.setTime = 0
      this.shiftName = ''
      this.vehicles = 1
      this.blackList = null
      this.saveNote = []
      this.service = []
      this.list = []
      this.selectedList = ''
      this.gender = 0
      this.serviceIdList = []
      this.serviceNameList = ''
    },
    _clearData() {
      this.clearLocationItemData('autoSearchLocation')
      this.clearLocationItemData('historyLocation')
      this.clearLocationItemData('intersectionLocation')
      this.clearLocationItemData('landmarkLocation')
      this.clearLocationItemData('searchLocation')
      this.emptyCustomerHistory()
      this.emptyDesignation()
      this.selectLocationMethod(0)
      this.clearMainAddress()
      this.initData()
      this.onClickOffLocationEmpty()
      this.$refs.customerSearch.clearData()
      this.$refs.customerOffSearch.clearData()
      this.$refs.HistoryLocation.resetState()
      this.$refs.IntersectionLocation.resetState()
      this.$refs.LandmarkLocation.resetState()
      this.$refs.reservationNonHail.resetTime()
      this.$refs.serviceSelect.clearFilterOnly()
    },
    emptyDesignation() {
      this.designationList.forEach((item) => {
        item.callNumber = null
      })
    },
    clearNote() {
      this.$refs.noteSelect.initial()
      this.$refs.noteSelect.clearNote()
      this.hailTaxiInfo.command = null
    },
    clearNoteAndRecord() {
      this.clearNote()
      BehaviorRecorder.record(
        '點擊',
        '派車頁面',
        `進線電話:(${this.hailTaxiInfo.customer_phone})，點擊清除(上車備註)`,
      )
    },
    updateContactPhone(contactPhone) {
      // 如果 contactPhone 不存在，設為空字串
      const phone = contactPhone || ''

      // 移除空格和連字符
      const cleanPhone = phone.replace(/[\s-]/g, '')
      // 更新聯絡電話
      this.updateHailTaxiInfo({ item: 'contact_phone', value: cleanPhone })
    },
    updateCustomerExist(value) {
      this.isCustomerExist = value
    },
    sameCustomerPhone() {
      // 移除空格和連字符
      const cleanPhone = this.hailTaxiInfo.customer_phone.replace(/[\s-]/g, '')
      this.hailTaxiInfo.contact_phone = cleanPhone
      this.hailTaxiInfo.customer_phone = cleanPhone
    },
    setNote(note) {
      // console.log(note);
      this.hailTaxiInfo.command = this._isEmpty(this.hailTaxiInfo.command)
        ? note
        : `${this.hailTaxiInfo.command},${note}`
    },
    recallHailingCar(value) {
      BehaviorRecorder.record('點擊', '派車頁面', '重新派一次')
      this.vehicles = value
      // 結果視窗關閉時已解鎖，這裡同步重新上鎖，避免 1 秒內被連點造成重複派單
      this.isHailingClick = true
      this.hasSendCar = true
      this.startHailingLockWatchdog()
      setTimeout(this.hailingTaxi, 1000)
    },
    serviceListChange(val) {
      this.hailTaxiInfo.customer_service = val
      if (val === null) {
        this.serviceIdList = []
        this.selectedList = ''
      }
    },
    setServiceSelected(val) {
      this.selectedList = val
    },
    setRemindTime(time) {
      this.remindTime = time
    },
    isUserValidToCallCar() {
      return cookies.get('GladServiceNumber') === 'null'
    },
    onAddressChange(addr) {
      this.hailTaxiInfo.on.address = addr
      /* 清空goolgle搜尋的舊地址*/
      this.$refs.customerSearch.clearGoogleSearchArray()
      /* 呼叫mixin onChange function才能出現藍底的地址選項*/
      this.onChange(addr)
    },
    onOffAddressChange(addr) {
      this.hailTaxiInfo.off.address = addr
      /* 清空goolgle搜尋的舊地址*/
      this.$refs.customerOffSearch.clearGoogleSearchArray()
      /* 呼叫mixin onChange function才能出現藍底的地址選項*/
      this.onChange(addr)
    },
    saveNonHailingBill() {
      if (this.isSavingNonHailingBill) return
      if (this.isUserValidToCallCar())
        return alert('目前此帳號無法用後派單功能')
      BehaviorRecorder.record('點擊', '派車頁面', '點擊儲存後派單')

      const reservationTime = this.$refs.reservationNonHail.getDate()
      if (this.hailTaxiInfo.on.address === null) {
        return alert('請輸入上車地點')
      }
      if (this._isEmpty(this.hailTaxiInfo.customer_phone)) {
        return alert('請輸入乘客電話')
      }
      if (isTimeInvalid(reservationTime)) {
        return alert('輸入日期錯誤')
      }
      this.isSavingNonHailingBill = true
      const payload = {
        callCarType: 0,
        callMethod: 1,
        cars: this.vehicles,
        dispatchAreaName: this.dispatchAreaName,
        distance: this.distance,
        offLocation: this.hailTaxiInfo.off.address,
        offLat: this.hailTaxiInfo.off.latitude,
        offLng: this.hailTaxiInfo.off.longitude,
        onLocation: this.hailTaxiInfo.on.address,
        onLat: this.hailTaxiInfo.on.latitude,
        onLng: this.hailTaxiInfo.on.longitude,
        passenComment: `${this.getAmountOfPassenger()}${this.getHailingBillComment()}`,
        passenNum: this.tmpPeople,
        passengerPhone: this.hailTaxiInfo.customer_phone,
        payType: 0,
        register: 4, //TODO: 之後去除
        platform: 4,
        serviceList: this.hailTaxiInfo.customer_service,
        shiftProgram: this.assignStrategy,
        taxiSort: 2,
        remindMinute: this.remindTime,
        reservationTime: reservationTime,
        blackList: this.blackList,
      }
      this.saveCustomerAPI('saveNonHailingBill')

      API.post('delayHail', payload)
        .then((res) => {
          if (res.success) {
            record.postRecord({
              type: '後派單派遣',
              event: '後派單儲存',
              code: cookies.get('GladTeamCode'),
              id: res.id,
              note: JSON.stringify(payload),
              user_name: cookies.get('GladName'),
              user_id: '',
            })
            BehaviorRecorder.record('顯示提醒', '派車頁面', '儲存後派單-成功')
            return alert('新增成功')
          }
          BehaviorRecorder.record('顯示提醒', '派車頁面', '儲存後派單-失敗')
        })
        .catch((e) => {
          this.$msg('網路不穩定請在操作一次')
          console.error(e)
        })
        .finally(() => {
          this.isSavingNonHailingBill = false
        })
    },
    emptyCustomerHistory() {
      this.customerHistoryInfo.notes = []
      this.customerHistoryInfo.serviceNotes = []
      this.customerHistoryInfo.getInInfors = []
      this.customerHistoryInfo.gps = []
      this.customerHistoryInfo.customerNote = []
    },
    phoneCheck(phone) {
      if (phone === null || phone === undefined) {
        alert('請輸入聯絡電話!')
        return false
      }

      // 檢查是否包含中文
      if (/[\u4e00-\u9fa5]/.test(phone)) {
        alert('電話號碼不能包含中文!')
        return false
      }

      // 檢查是否包含特殊符號 (除了數字以外的字元)
      if (/[^\d]/.test(phone)) {
        alert('電話號碼只能包含數字!')
        return false
      }

      return true
    },
    async saveCustomerAPI(task) {
      let result
      if (this.isCustomerExist) {
        // 有找到資料，呼叫 updateCustomer
        result = await customer.updateCustomer(this.getCustomerInfo(task), true)
        console.log('updateCustomer', result)
      } else {
        // 沒有找到資料，呼叫 createCustomer
        result = await customer.createCustomer(this.getCustomerInfo(task), true)
        // 建立後視為有資料
        this.isCustomerExist = true
        console.log('createCustomer', result)
      }
      if (result.success) {
        this.customerId = result.result.id
        if (task === 'immediatelyHailing') {
          this.hailingTaxi()
        }
        return
      }
      BehaviorRecorder.record(
        '顯示提醒',
        '派車頁面',
        '儲存乘客資料erro- ' + result.message,
      )
      this.isHailingClick = false
      this.releaseHaveSendedOrderCondition()
      this.$msg(`儲存乘客資料-${result.message} 請再操作一次`)
    },
  },
  components: {
    NoteSelect,
    AutoComplete,
    PreviousReserveCar,
    CustomerSearch,
    HailResultModal,
    ReservationModal,
    ServiceSelect,
    RefactorSection,
    MinorNote,
    DateSelect,
    PassengerInfoTable,
    IntersectionLocation,
    LandmarkLocation,
    HistoryLocation,
    BaseButton,
    MapDialog,
    OffCustomerSearch,
  },
  computed: {
    ...mapState('hail', {
      vx_serviceList: 'serviceList',
    }),
  },
  async mounted() {
    try {
      const { result } = await reqServiceList()
      this.vx_setServiceList(result.serviceList)
      if (this.isUserValidToCallCar())
        return alert('目前此帳號無法用立即派車功能')
      this.inputArea = cookies.get('GladArea')
      this.hailTaxiInfo.customer_phone = this.$route.query.ANI
      this.hailTaxiInfo.contact_phone = this.$route.query.ANI
      /* 進線電話帶入直接執行查詢 */
      this.$refs.passengerInfoTable.onSearchWithANI(this.$route.query.ANI)
      if (
        this.hailTaxiInfo.customer_phone !== undefined &&
        this.hailTaxiInfo.customer_phone !== ''
      ) {
        BehaviorRecorder.record(
          '自動查詢',
          '派車頁面',
          '查詢電話' + this.hailTaxiInfo.customer_phone,
        )
        this.searchCustomerInfo()
      }
      if (cookies.get('GladTeamCode') === '300') {
        this.distance = 10000
      } else {
        this.distance = 5000
      }
      this._socketConnection('叫車頁面mounted時的socket連線')
      // 檢查identificaiton code與伺服器相同
      kmlTool.getDispatchCode()
      kmlTool.getSchualedCode()
      this.orderRemindIntervalId = setInterval(() => {
        orderRemind()
      }, 120 * 1000)
    } catch (e) {
      console.error(e)
    }
  },
  beforeDestroy() {
    this._closeSocket()
    clearInterval(this.orderRemindIntervalId)
    this.stopHailingLockWatchdog()
  },
}
</script>

<style scoped lang="scss">
.phoneHail {
  &__title {
    font-size: 18px;
    color: black;
    margin: 0;
    margin-left: 15px;
    height: 36px;
    line-height: 36px;
    // 避免col沒滿12時自動分配，對齊用的固定寬度
    max-width: 247.15px;
  }

  &__radio {
    margin: 0;
    height: 36px;
    vertical-align: top;
  }

  &__rowContainer {
    margin-top: 5px;
    min-height: 55px;
    display: flex;
    align-items: center;
    border: #989898 solid 2px;
    background: #ffe6e6;

    &--reservation {
      background: #e6ffe6;
    }

    &--previousReserve {
      background: #e6ecff;
    }
  }

  &__subRow {
    min-height: 55px;
    display: flex;
    align-items: center;
  }

  &__inputField {
    width: 100%;
    height: 36px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  &__button {
    height: 36px;
    margin: 0;
    margin-left: 10px;
    outline: none;

    &--clear {
      width: 65px;
    }

    &--autoHailing {
      width: 100px;
    }
  }

  &__checkbox {
    zoom: 150%;
    margin: 0;
  }

  &__select {
    width: 100%;
    height: 36px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  &__offCustomerSearch {
    padding: 10px;
  }
}

.color_red {
  color: #ff1a1a;
}

.driverTitle {
  display: inline-block;
}

/* Optional: Makes the sample page fill the window. */
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#floating-panel {
  position: absolute;
  top: 10px;
  left: 25%;
  z-index: 5;
  background-color: #fff;
  padding: 5px;
  border: 1px solid #999;
  text-align: center;
  font-family: 'Roboto', 'sans-serif';
  line-height: 30px;
  padding-left: 10px;
}

ul,
li {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.hailing-style {
  border: #989898 solid 2px;
  padding: 5px;
}

.input-hailing-style {
  background: #ffe6e6;
}

.input-delay-hailing {
  background: #e6ffe6;
}

.yellow {
  background-color: #ffffb3;
}

.hailing {
  color: #101010;
}
</style>



// WEBPACK FOOTER //
// src/pages/hailTaxi/PhoneHail.vue